import { Link } from 'react-router-dom';
import { BsArrowLeftShort } from 'react-icons/bs';

const ErrorPage = () => {
  return (
    <div
      className='errorPageSec flex md:px-0 px-4 items-center justify-center w-screen h-screen bg-eventtext-eventLightYellow
        '>
      <div className='max-w-7xl mx-auto px-6 sm:px-40 py-12 sm:py-20 bg-white rounded-2xl shadow-2xl '>
        <div className='flex flex-col items-center w-full'>
          <h1 className='font-bold text-eventLightYellow text-7xl sm:text-9xl'>
            404
          </h1>
          <h6 className='mb-2 text-xl font-bold text-center text-gray-800 sm:text-xl md:text-3xl'>
            <span className='text-red-500'>Oops!</span> Page not found
          </h6>
          <p className='mb-8 text-center text-xs text-eventGray md:text-lg'>
            The page you’re looking for doesn’t exist.
          </p>
          <Link
            to='/'
            className='flex items-center justify-center px-3 py-1 sm:py-2 text-sm font-semibold text-white hover:text-white rounded-md bg-eventLightYellow'>
            <BsArrowLeftShort size={30} /> Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
